import React, { useState, useEffect } from "react";
import { Button, Typography } from "@mui/material";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//Modal Pages
import ScanReceipt from "./ScanReceipt";
import ScanBarcode from "./ScanBarcode";
import AddIndividualItem from "./AddIndividualItem";
import VoiceToPantry from "./VoiceToPantry";

//Actions
import { changeAddModalView } from "../../../../actions/pantry";

const Initial = ({ pantry: { locations, loading, error, modals }, changeAddModalView }) => {
  const handleIndividualItem = () => {
    changeAddModalView({ type: "single", stage: "location" });
  };

  const handleVoice = () => {
    changeAddModalView({ type: "voice", stage: "location" });
  };

  const handleReceipt = () => {
    changeAddModalView({ type: "receipt", stage: "location" });
  };

  const initialHTML = (
    <div className="flex flex-col justify-between min-h-[25vh] w-full">
      <div className="p-4 bg-neutral-100">
        <Typography variant="h6" className="font-normal">
          Add Ingredients
        </Typography>
      </div>
      <div className="p-4">
        <div className="mb-2">
          <Button
            variant="contained"
            className="bg-stone-800 hover:bg-stone-700"
            fullWidth
            disableElevation
            onClick={handleIndividualItem}
          >
            + Add Individual Item
          </Button>
        </div>

        <div className="mb-2">
          <Button
            variant="contained"
            className="bg-stone-800 hover:bg-stone-700"
            fullWidth
            disableElevation
            onClick={handleVoice}
          >
            + Add By Voice
          </Button>
        </div>
        <div className="mb-2">
          <Button
            variant="contained"
            className="bg-stone-800 hover:bg-stone-700"
            fullWidth
            disableElevation
            onClick={handleReceipt}
          >
            + Scan Receipt
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="max-h-[90vh] w-full">
      {modals?.add?.type === "initial" && initialHTML}
      {modals?.add?.type === "receipt" && <ScanReceipt />}
      {modals?.add?.type === "barcode" && <ScanBarcode />}
      {modals?.add?.type === "single" && <AddIndividualItem />}
      {modals?.add?.type === "voice" && <VoiceToPantry />}
    </div>
  );
};

Initial.propTypes = {
  pantry: PropTypes.object.isRequired,
  changeAddModalView: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  pantry: state.pantry,
});

export default connect(mapStateToProps, { changeAddModalView })(Initial);
